function getBasePath() {
  return process.env.VUE_APP_API_SERVER;
}

function getILBasePath() {
  return process.env.VUE_APP_IL_API_SERVER;
}

export { getBasePath, getILBasePath };
